var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g4, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationNoShortlist(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 200,
    viewBox: "0 0 209 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 200c55.228 0 100-44.772 100-100S155.228 0 100 0 0 44.772 0 100s44.772 100 100 100z",
    fill: "#B47DF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-no-shortlist_svg__filter0_d_31_1819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 58H81a6 6 0 00-6 6v75a6 6 0 006 6h64a6 6 0 006-6V64a6 6 0 00-6-6z",
    fill: "#C8D5FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-no-shortlist_svg__filter1_d_31_1819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137 50H61a6 6 0 00-6 6v93a6 6 0 006 6h76a6 6 0 006-6V56a6 6 0 00-6-6z",
    fill: "#C8D5FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-no-shortlist_svg__filter2_d_31_1819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.003 42.999h-77a6 6 0 00-6 6v108a6 6 0 006 6h77a6 6 0 006-6v-108a6 6 0 00-6-6z",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.102,
    d: "M118 133H61a2 2 0 00-2 2v2a2 2 0 002 2h57a2 2 0 002-2v-2a2 2 0 00-2-2zM107 142H73a2 2 0 00-2 2v1a2 2 0 002 2h34a2 2 0 002-2v-1a2 2 0 00-2-2z",
    fill: "#0D2976"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108 56.001H70a9 9 0 100 18h38a9 9 0 009-9 9 9 0 00-9-9z",
    fill: "#F6FBA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108 101c0-10.493-8.507-19-19-19s-19 8.507-19 19 8.507 19 19 19 19-8.507 19-19z",
    fill: "#4B75FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.625 104.656h7.925s-.957 4.2 0 6.379c.957 2.179-8.822 1.544-7.925 0 .897-1.544 0-6.379 0-6.379z",
    fill: "#D39F2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.186,
    d: "M89.796 96.306c4.079.142 4.12 1.798 4.12 4.02v2.672c0 2.218-2.807 4.016-4.121 4.016-1.314 0-4.12-1.798-4.12-4.016v-2.672c0-2.222.043-4.163 4.121-4.02z",
    fill: "#0D2976"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.909 108.549c.272.1 2.192 1.541 4.119 1.514a5.516 5.516 0 003.039-1.514c8.388 1.571 10.215 3.447 10.215 5.761v4.714a4.136 4.136 0 01-4.079 4.19H80.337a4.135 4.135 0 01-4.079-4.19s-.1-2.543 0-4.714c.1-2.171 2.5-3.778 9.651-5.761z",
    fill: "#EEF755"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.755 96.746a.97.97 0 00-1.928.203l.356 3.375a.97.97 0 101.928-.203l-.356-3.375z",
    fill: "#D39F2A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.796 88.117c6.757.258 6.829 3.254 6.829 7.268v4.846c0 4.014-4.652 7.268-6.829 7.268-2.177 0-6.829-3.256-6.829-7.268v-4.847c0-4.013.071-7.526 6.829-7.267z",
    fill: "#D39F2A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.766 96.95a.97.97 0 10-1.929-.204l-.356 3.375a.97.97 0 101.928.204l.357-3.375z",
    fill: "#D39F2A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.796 107.497h-.006V88.116h.006c3.118.119 5.008.827 5.949 2.226.88 1.309.88 3.123.88 5.042v4.845a7.339 7.339 0 01-2.6 5.139 9.872 9.872 0 01-2.244 1.558 4.8 4.8 0 01-1.985.571z",
    fill: "#BE8D21"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.961 97.894v-2.51c0-1.833 0-3.729.793-5.093a3.8 3.8 0 011.828-1.595 8.752 8.752 0 013.526-.593c.219 0 .449 0 .681.013 3.118.119 5.008.826 5.948 2.226.88 1.309.88 3.123.88 5.042v1.229c-.549-.047-1.81-.18-4.091-.537-1.532-.274-3-.83-4.33-1.638a15.292 15.292 0 01-1.85-1.249l-.378.74c0-.006-.284-.639-.576-.639a.29.29 0 00-.232.156 1.56 1.56 0 00-.2.812 5.362 5.362 0 01-.427 1.818 3.013 3.013 0 01-1.572 1.817v.001z",
    fill: "#0D2976"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-no-shortlist_svg__filter3_d_31_1819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 30c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z",
    fill: "#FF7181"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.578 29.5l3.906 3.945a1.16 1.16 0 010 1.72l-.859.858a1.16 1.16 0 01-1.719 0L180 32.117l-3.945 3.906a1.16 1.16 0 01-1.719 0l-.859-.859a1.16 1.16 0 010-1.719l3.906-3.945-3.906-3.906a1.16 1.16 0 010-1.719l.859-.86a1.16 1.16 0 011.719 0L180 26.923l3.906-3.906a1.16 1.16 0 011.719 0l.859.859a1.16 1.16 0 010 1.719l-3.906 3.906z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "illustration-no-shortlist_svg__filter0_d_31_1819",
    x: 63,
    y: 52,
    width: 100,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_1819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_31_1819",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-no-shortlist_svg__filter1_d_31_1819",
    x: 43,
    y: 44,
    width: 112,
    height: 129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_1819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_31_1819",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-no-shortlist_svg__filter2_d_31_1819",
    x: 35.003,
    y: 42.999,
    width: 109,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_1819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_31_1819",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-no-shortlist_svg__filter3_d_31_1819",
    x: 154,
    y: 7,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0509804 0 0 0 0 0.160784 0 0 0 0 0.462745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_1819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_31_1819",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationNoShortlist);
export default ForwardRef;